var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3301 12.3301C22.3301 6.81008 17.8501 2.33008 12.3301 2.33008C6.81008 2.33008 2.33008 6.81008 2.33008 12.3301C2.33008 17.1701 5.77008 21.2001 10.3301 22.1301V15.3301H8.33008V12.3301H10.3301V9.83008C10.3301 7.90008 11.9001 6.33008 13.8301 6.33008H16.3301V9.33008H14.3301C13.7801 9.33008 13.3301 9.78008 13.3301 10.3301V12.3301H16.3301V15.3301H13.3301V22.2801C18.3801 21.7801 22.3301 17.5201 22.3301 12.3301Z",
    fill: "#D6C79D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.2b5ecb544aed98ef3c923a998cfb3248.svg";
export { ForwardRef as ReactComponent };